export default (text) => {
  if (!text) return '';
  // const tmp = document.createElement('DIV');
  // tmp.innerHTML = text;
  // return tmp.textContent || tmp.innerText || '';
  // return text.replace(/([^a-z0-9]+)/gi, '');
  return text.replace(/[^\x20-\x7E]/g, '');
};



// WEBPACK FOOTER //
// ./app/src/shared/textFilter.js